import * as React from 'react';
import TabbedContent from '../../../../components/TabbedContent';

import AccountantsMapGraphic from './assets/accountants-map.inline.svg';
import SolicitorsMapGraphic from './assets/solicitors-map.inline.svg';
import BarristersMapGraphic from './assets/barristers-map.inline.svg';
import BuiltEnvMapGraphic from './assets/built-environment-map.inline.svg';

import './style.scss';

const ProgramFindingsSection = () => {
  const tabs = [
    {
      title: 'Accountants',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <AccountantsMapGraphic alt="Australian map graph showing the average number of persons in accounting sector by state and territory subject to professional standards schemes" />
          </div>
          <div className="text">
            <p>The accounting profession reported a number of improvements throughout the year including:</p>
            <ul>
              <li>
                engaging with brokers and insurers to facilitate members accessing affordable professional indemnity
                insurance
              </li>
              <li>
                undertaking comprehensive auditing activities to monitor compliance with membership entry requirements
              </li>
              <li>
                enhancing by-laws and membership policies to improve member awareness of professional indemnity
                insurance requirements.
              </li>
            </ul>

            <p className="sr-only">WA: 4,311</p>
            <p className="sr-only">NT: 216</p>
            <p className="sr-only">SA: 2,733</p>
            <p className="sr-only">QLD: 7,501</p>
            <p className="sr-only">NSW: 16,166</p>
            <p className="sr-only">ACT: 946</p>
            <p className="sr-only">VIC: 12,340</p>
            <p className="sr-only">TAS: 557</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Solicitors',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <SolicitorsMapGraphic alt="Australian map graph average number of solicitors by state and territory subject to professional standards schemes" />
          </div>
          <div className="text">
            <p>There were improvements in several areas by solicitors including:</p>
            <ul>
              <li>
                conducted monitoring and compliance activities to ensure scheme participants have appropriate
                professional indemnity insurance
              </li>
              <li>
                one association reviewed risk management strategies to identify new risks and controls to mitigate the
                risks
              </li>
              <li>
                two associations conducted root cause analysis on claims and complaints data to identify actions to
                prevent the risk and enhance early and targeted intervention programs.
              </li>
            </ul>

            <p className="sr-only">WA: 2,187</p>
            <p className="sr-only">NT: 0</p>
            <p className="sr-only">SA: 1,738</p>
            <p className="sr-only">QLD: 6,818</p>
            <p className="sr-only">NSW: 17,499</p>
            <p className="sr-only">ACT: 0</p>
            <p className="sr-only">VIC: 5,464</p>
            <p className="sr-only">TAS: 0</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Barristers',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <BarristersMapGraphic alt="Australian map graph average number of barristers by state and territory subject to professional standards schemes" />
          </div>
          <div className="text">
            <p>Noticeable improvements were observed across several bar associations including:</p>
            <ul>
              <li>identifying new and emerging risks and implementing controls to manage these risks</li>
              <li>
                one association conducted a continuing professional development audit and utilised the findings to
                develop a Competency Framework
              </li>
              <li>
                two associations implemented changes and initiatives to respond to risks of sexual harassment and
                bullying
              </li>
              <li>
                one association undertook an audit to monitor compliance with the scheme participant’s obligations to
                disclose their limited liability status and utilised the findings to conduct a continuing professional
                development session.
              </li>
            </ul>

            <p className="sr-only">WA: 266</p>
            <p className="sr-only">NT: 0</p>
            <p className="sr-only">SA: 242</p>
            <p className="sr-only">QLD: 1,021</p>
            <p className="sr-only">NSW: 2,338</p>
            <p className="sr-only">ACT: 0</p>
            <p className="sr-only">VIC: 1,421</p>
            <p className="sr-only">TAS: 0</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Built Environment',
      content: (
        <div className="program-findings-tab-content">
          <div className="graphic">
            <BuiltEnvMapGraphic alt="Australian map graph verage number of persons in built environment sector by state and territory subject to professional standards schemes" />
          </div>
          <div className="text">
            <p>Achievements observed in the built environment sector included:</p>
            <ul>
              <li>
                undertaking comprehensive activities to inform scheme participants of their obligations and ensure
                compliance with the professional standards legislation and scheme
              </li>
              <li>
                compliance with the Annual Membership Assurance Report verifying the number of scheme participants for
                the annual fee period and annual fee payments
              </li>
              <li>
                two associations conducted root cause analysis using data inputs and identified risk management
                strategies to mitigate the identified risks.
              </li>
            </ul>

            <p className="sr-only">WA: 537</p>
            <p className="sr-only">NT: 72</p>
            <p className="sr-only">SA: 437</p>
            <p className="sr-only">QLD: 1,343</p>
            <p className="sr-only">NSW: 4,474</p>
            <p className="sr-only">ACT: 496</p>
            <p className="sr-only">VIC: 1,885</p>
            <p className="sr-only">TAS: 119</p>
          </div>
        </div>
      ),
    },
    {
      title: 'Common Topics',
      content: (
        <div className="program-findings-tab-content common-topics">
          <div className="text">
            <p>Common areas of achievement</p>
            <p>
              Three common areas of achievement have been identified. These are areas where there were positive
              developments and improvements in performance of professional standards schemes.
            </p>
            <ul>
              <li>Scheme administration and Annual Membership Assurance Reporting</li>
              <li>Conducting risk analysis and utilising root cause analysis as a risk management tool</li>
              <li>Continuing Professional Development</li>
            </ul>
          </div>
          <div className="text">
            <p>Common areas for improvement</p>
            <p>
              Three common areas for improvement have been identified, each of them continuing over from the previous
              year. The Councils are continuing to encourage and assist associations to improve in these areas.
            </p>
            <ul>
              <li>Complaints and discipline system improvements</li>
              <li>Scheme monitoring improvements</li>
              <li>Discretionary caps and exemptions</li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  return (
    <section className="l-program-findings-section">
      <div className="container">
        <h2 className="section-title">Professional Standard Improvement Program Findings</h2>
        <TabbedContent tabs={tabs} />
      </div>
    </section>
  );
};

export default ProgramFindingsSection;
